module.exports = __webpack_public_path__ + "static/media/رحلات الى أوروبا.7927cd88.jpg";